import { Tab, Tabs } from 'react-bootstrap';
import DataReleaseHistoryChart from '@/modules/calendar/components/data/data-release-history-chart';
import DataReleaseHistoryTable from '@/modules/calendar/components/data/data-release-history-table';
import DataReleaseHistoryDownload from '@/modules/calendar/components/data/data-release-history-download';
import { RequirePermissions, Permissions } from '@/core/permissions/export';
import useDataReleaseHistory from '@/modules/calendar/hooks/use-data-release-history';

export default function DataReleaseHistory({
  dataReleaseId,
  date,
}: {
  dataReleaseId: number | string;
  date?: string;
}) {
  const { events, selectedRelease } = useDataReleaseHistory(dataReleaseId, date);

  if (!selectedRelease) return <></>;

  if (selectedRelease.series.length === 0) return <></>;

  return (
    <>
      <Tabs justify={true}>
        <Tab title={'Chart'} eventKey={'chart'} className={' h-100 overflow-auto'}>
          <div className={'mt-2'}>
            <DataReleaseHistoryChart events={events} selectedRelease={selectedRelease} />
          </div>
        </Tab>
        <Tab title={'Table'} eventKey={'table'} className={' h-100 overflow-auto'}>
          <div className={'mt-2'}>
            <DataReleaseHistoryTable events={events} selectedRelease={selectedRelease} />
          </div>
        </Tab>
      </Tabs>
      <div>
        <RequirePermissions allow={Permissions.ALPHA_ACCESS}>
          <DataReleaseHistoryDownload events={events} selectedRelease={selectedRelease} />
        </RequirePermissions>
      </div>
    </>
  );
}
